import { AuthService } from 'src/app/core/auth.service';
import { Injectable, EventEmitter, Output } from '@angular/core';
import { ApiService } from './api.service';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LocationSwitchService {
  public locations: BehaviorSubject<any[]>;
  public serverDate: BehaviorSubject<any>;

  CURRENT_LOCATION_KEY: string = 'CURRENT_LOCATION_ID';

  serverDateChanged = new EventEmitter<string>();
  locationChanged = new EventEmitter<string>();

  constructor(
    private locationService: ApiService,
    private authService: AuthService
  ) {
    this.locations = new BehaviorSubject([]);
    this.serverDate = new BehaviorSubject('');

    this.getAllLocations();
    this.loadServerDate();
  }

  getAllLocations() {
    const userInfo = this.authService.user;
    const userId = userInfo?.Id || 0; 

    const isPortal = window.location.href.includes('portal');
    const url = isPortal ? `/account/location/get?userId=${userId}` : `/account/location/get`;
    this.locationService
      .get(url)
      .subscribe((response: any[]) => {
        if (response) {
          this.locations.next(response);
        }
      });
  }

  loadServerDate() {
    this.locationService.getServerDate().subscribe((response: any) => {
      if (response) {
        this.serverDate.next(response);
      }
    });
  }

  setCurrentLocation(locId) {
    localStorage.setItem(this.CURRENT_LOCATION_KEY, locId);
    this.locationChanged.emit(locId);
  }

  getCurrentLocation() {
    const userInfo = this.authService.user;

    if (
      localStorage.getItem('currentLocation') &&
      ![1, 2, 3, 4].includes(userInfo.RoleId)
    ) {
      const currentLocation = JSON.parse(
        localStorage.getItem('currentLocation')
      );
      return currentLocation.LocationId || '0';
    }
    return localStorage.getItem(this.CURRENT_LOCATION_KEY) || '0';
  }

  getCurrentLocationInfo() {
    let l = this.locations.value.find((loca) => {
      return loca.Id == this.getCurrentLocation();
    });
    return l;
  }
}
